import { Program } from "./Program";
import { Store } from "./Store";

export interface LabelTemplate {
    id: number;
    active: boolean;
    name: string;
    template: string;
    type: LabelTemplateType;
    stores?: Store[];
    programs?: Program[];
    states?: string[];
}

export class LabelTemplate {
    constructor(obj?: Partial<LabelTemplate>) {
        if (obj) Object.assign(this, obj);
    }
}

export enum LabelTemplateType {
    bottleLabel,
    bottleLabelQrCode
}